The identifier for the `ApplicationLibraryQuestionSearchResult`.
